import { BannersDTO } from '../types';
import { ModalKeys } from '../chooseModal';

export interface IInitialState {
  banners: BannersDTO[];
  loading: boolean;
  selectedBanner: BannersDTO | null;
  choosenModal: ModalKeys | null;
}

export const actionPageTypes = {
  SET_BANNERS: 'SET_BANNERS' as const,
  SET_SELECTED_BANNER: 'SET_SELECTED_BANNER' as const,
  SET_LOADING: 'SET_LOADING' as const,
  SET_CHOOSEN_MODAL: 'SET_CHOOSEN_MODAL' as const,
};

export type ActionTypes =
  | {
  type: typeof actionPageTypes.SET_BANNERS;
  payload: BannersDTO[];
}
  | { type: typeof actionPageTypes.SET_LOADING; payload: boolean }
  | {
  type: typeof actionPageTypes.SET_CHOOSEN_MODAL;
  payload: null | ModalKeys;
}
  | {
  type: typeof actionPageTypes.SET_SELECTED_BANNER;
  payload: null | BannersDTO;
};
